<div class="p-6">
  @if (loading) {
    <div class="flex justify-center py-12"><div class="animate-spin rounded-full h-7 w-7 border-b-2 border-brand-500"></div></div>
  }

  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (!loading) {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-6">

      <!-- Datos básicos -->
      <section class="space-y-4">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Datos básicos</h3>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Nombre <span class="text-error-500">*</span>
          </label>
          <input type="text" formControlName="name" placeholder="Ej. Ventas"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
            [class.border-error-500]="hasError('name')" [class.border-gray-300]="!hasError('name')"/>
          @if (hasError('name')) { <p class="mt-1.5 text-sm text-error-500">{{ getError('name') }}</p> }
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Descripción</label>
          <textarea formControlName="description" rows="3" placeholder="Tareas relacionadas con ventas"
            class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"></textarea>
        </div>
      </section>

      <!-- Color -->
      <section class="space-y-3">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Color</h3>

        <div class="flex flex-wrap gap-2">
          @for (c of COLOR_PRESETS; track c) {
            <button type="button" (click)="setColor(c)"
              class="w-8 h-8 rounded-lg border-2 transition-all hover:scale-110"
              [style.background-color]="c"
              [class.border-gray-900]="form.value.color === c"
              [class.dark:border-white]="form.value.color === c"
              [class.border-transparent]="form.value.color !== c"
              [title]="c">
            </button>
          }
        </div>

        <div class="flex items-center gap-3">
          <div class="relative">
            <input type="color" formControlName="color"
              class="absolute inset-0 w-12 h-12 opacity-0 cursor-pointer"/>
            <div class="w-12 h-12 rounded-lg border-2 border-gray-200 dark:border-gray-700 shadow-sm pointer-events-none"
              [style.background-color]="form.value.color || '#2196F3'"></div>
          </div>
          <input type="text" formControlName="color" placeholder="#2196F3"
            class="flex-1 h-11 rounded-lg border border-gray-300 bg-transparent px-3 text-sm font-mono uppercase dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"/>
        </div>
      </section>

      <!-- Activo -->
      <section>
        <label class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/40 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/60 transition-colors">
          <div class="relative inline-flex shrink-0 mt-0.5">
            <input type="checkbox" formControlName="isActive" class="peer sr-only"/>
            <div class="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer-checked:bg-brand-500 transition-colors"></div>
            <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
          </div>
          <div class="flex-1">
            <span class="block text-sm font-medium text-gray-800 dark:text-gray-100">Categoría activa</span>
            <span class="block text-xs text-gray-500">Si se desactiva, no aparecerá en los selectores al crear tareas.</span>
          </div>
        </label>
      </section>

      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
        <app-button variant="primary" type="submit" [disabled]="saving || form.invalid">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </app-button>
      </div>
    </form>
  }
</div>
